import { Injectable } from '@angular/core'
import { CanMatch, UrlTree } from '@angular/router'
import { Observable } from 'rxjs'
import { FeatureFlagsService } from '../services/feature-flag.service'

@Injectable({ providedIn: 'root' })
export class WatchesGuard implements CanMatch {
  private isWatchesEnabled: boolean
  private subscriptions = [
    this.featureFlagsService.watches$.subscribe(({ isEnabled })=>{
      this.isWatchesEnabled = isEnabled
    })
  ]
  constructor (
    private featureFlagsService: FeatureFlagsService
  ){}
  ngOnDestroy ():void{
    this.subscriptions.forEach(((subscription)=>subscription.unsubscribe()))
  }
  canMatch (): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.isWatchesEnabled
  }
}
